/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import PreCutPopup from "common/vue/components/PreCutPopup.react.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { generateTimeRemainingText } from "common/utils/ui/generate-time-remaining";
import { trackRudderstackImageEdited } from "common/utils/rudderstack/tracker.react";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "./store";
import "./PreCut.scss";

export default function PreCut({ isModal = false, ...restProps }) {
  const { t, n } = useI18n();
  const store = useDtfStore();

  function preCutPrice() {
    // @ts-expect-error TS(4111): Property 'preCutPrice' comes from an index signatu... Remove this comment to see the full error message
    return store.preCutPrice;
  }

  function preCut() {
    // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
    return store.preCut;
  }

  function preCutUpsellThreshold() {
    // @ts-expect-error TS(4111): Property 'preCutUpsellThreshold' comes from an ind... Remove this comment to see the full error message
    return store.preCutUpsellThreshold;
  }

  function enablePreCut() {
    // @ts-expect-error TS(4111): Property 'enablePreCut' comes from an index signat... Remove this comment to see the full error message
    return store.enablePreCut;
  }

  // @ts-expect-error TS(6133): 'experiments' is declared but its value is never r... Remove this comment to see the full error message
  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return store.experiments;
  }

  function totalQuantity() {
    // @ts-expect-error TS(4111): Property 'totalQuantity' comes from an index signa... Remove this comment to see the full error message
    return store.totalQuantity;
  }

  function preCutDuration() {
    // @ts-expect-error TS(4111): Property 'preCutDuration' comes from an index sign... Remove this comment to see the full error message
    return store.preCutDuration;
  }

  function productCartQuantity() {
    // @ts-expect-error TS(4111): Property 'productCartQuantity' comes from an index... Remove this comment to see the full error message
    return store.productCartQuantity;
  }

  function dtfCategory() {
    // @ts-expect-error TS(4111): Property 'dtfCategory' comes from an index signatu... Remove this comment to see the full error message
    return store.dtfCategory;
  }

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return store.showMultiSize;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return store.isSpangle;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return store.sticker;
  }

  function businessLine() {
    // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
    return store.businessLine;
  }

  function isProColor() {
    // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
    return store.isProColor;
  }

  function totalSeconds() {
    // round up to nearest minute
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Math.ceil((preCutDuration() * cartPlusQuantity()) / 60) * 60;
  }

  function cartPlusQuantity() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return productCartQuantity() + totalQuantity();
  }

  function showPreCutUpsell() {
    const showUpsell = Boolean(totalQuantity());
    if (preCutUpsellThreshold()) {
      const savedMinutes = totalSeconds() / 60;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return savedMinutes >= preCutUpsellThreshold() && showUpsell;
    }
    return showUpsell;
  }

  function totalQuantityText() {
    return t("item", cartPlusQuantity());
  }

  function preCutSavedTimeText() {
    // convert to milliseconds first
    return generateTimeRemainingText(totalSeconds() * 1000 + Date.now());
  }

  function updatePreCut(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updatePreCut(...args);
  }

  function submitPreCutEvent() {
    const newState = preCut() ? "disable" : "enable";
    submitDtfEvent("pre_cut_toggle", {
      pre_cut: newState,
      is_upsell: true,
      page: "pdp"
    });
    const detectProductLine = (obj: any) => {
      if (obj.sticker) return "sticker";
      if (obj.isProColor) return "pro color";
      if (obj.isSpangle) return "spangle";
      return "dtf";
    };
    trackRudderstackImageEdited({
      product_line: detectProductLine({
        sticker: sticker(),
        isProColor: isProColor(),
        isSpangle: isSpangle()
      }),
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artwork: artworks()[0],
      edit_type: newState === "enable" ? "precut transfer selected" : "precut transfer removed",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks_count: artworks().length,
      location: "pdp",
      pre_cut_transfers: preCut(),
      business_line: businessLine()
    });
  }

  function togglePreCut() {
    submitPreCutEvent();
    updatePreCut(!preCut());
  }

  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("pre-cut scope-52b1b65c", restProps?.className, {
        "pre-cut--mau": isModal,
        "pre-cut--multi-size": showMultiSize()
      })}
    >
      {showPreCutUpsell() ? (
        <div className="pre-cut__upsell scope-52b1b65c">
          <span className="pre-cut__upsell-title scope-52b1b65c">Save {preCutSavedTimeText()}</span>
          <br className="scope-52b1b65c" /> By letting us precut your{" "}
          <span className="pre-cut__upsell-quantity scope-52b1b65c">{totalQuantityText()}</span>
          {}
          {productCartQuantity() ? (
            <span className="pre-cut__upsell-cart-quantity scope-52b1b65c">
              , including{" "}
              <span className="pre-cut__upsell-quantity scope-52b1b65c">
                {/* @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'ReactNod... Remove this comment to see the full error message */}
                {productCartQuantity()}
              </span>{" "}
              from your cart
            </span>
          ) : null}
          . {}
        </div>
      ) : (
        <div className="pre-cut__title scope-52b1b65c">Want to save time?</div>
      )}
      <div className="pre-cut__checkbox-wrapper scope-52b1b65c">
        <label
          className={cn("pre-cut__label scope-52b1b65c", {
            "pre-cut__label--standard-artwork": isStandardArtwork()
          })}
          data-testid="pre-cut-label"
        >
          <span className="scope-52b1b65c sr-only">Pre-cut</span>
          <input
            className="pre-cut__input js-pre-cut-checkbox scope-52b1b65c"
            type="checkbox"
            // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
            checked={preCut()}
            disabled={!enablePreCut()}
            onChange={togglePreCut}
            data-testid="pre-cut-input"
          />

          <span className="pre-cut__icon-wrapper scope-52b1b65c" />
          {preCut() ? (
            <UseSvg
              className="pre-cut__icon pre-cut__icon--full scope-52b1b65c"
              icon="check"
              data-testid="pre-cut-icon"
            />
          ) : null}
        </label>
        <div
          className={cn("scope-52b1b65c", {
            "pre-cut__text": true,
            "pre-cut__text--bold": preCut()
          })}
        >
          {" "}
          {/* @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message */}
          Pre-cut transfers ({n(preCutPrice(), "currency")} each){" "}
        </div>
        <PreCutPopup className="pre-cut__info scope-52b1b65c" data-testid="pre-cut-info" />
      </div>
      <div className="pre-cut__upsell-note scope-52b1b65c">
        {" "}
        This applies to all {dtfCategory() as string} orders{" "}
      </div>
    </div>
  );
}
